<template>
<div>

    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="card box-margin">
                    <div class="card-header">
                        <i class="fas fa-file-invoice"></i><span> Nueva Cotización</span>
                        <div class="btn-group" role="group">
                            <template v-if="AsignarRolPermisosByUsuario.includes('categoria.crear')">
                                <router-link class="btn btn-primary" :to="'/cotizaciones'"><i class="far fa-arrow-alt-circle-left"></i> Regresar</router-link>
                            </template>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="shortcode-html">
                            <div class="row border"  style="padding-top:10px">

                                <div class="col-md-4 col-sm-4 col-lg-4" :class="bloquear_seguros ? 'bloquear' : ''">
                                    <div class="form-group">
                                            <label>Cliente</label>

                                            <v-select
                                                v-model="vaCreCoti.nombreCliente"
                                                @search="selectCliente"
                                                label="nombre"
                                                :options="arrayCliente"
                                                placeholder="Buscar Cliente..."
                                                 @input="getDatosCliente"
                                            >
                                            <span slot="no-options">Lo siento, no hay opciones coincidentes.</span>
                                            </v-select>
                                    </div>
                                </div>

                                 <div class="col-md-2 col-sm-2 col-lg-2">
                                    <div class="form-group">
                                        <label>Edad</label>
                                        <input type="text" class="form-control bloquear" id="edad" v-model="vaCreCoti.edadCliente">
                                    </div>
                                </div>
                                <div class="col-md-2 col-sm-2 col-lg-2">
                                    <div class="form-group">
                                        <label>Año de Antiguedad</label>
                                        <input type="text" class="form-control" id="anio_antiguedad" v-model="vaCreCoti.anio_antiguedad">
                                    </div>
                                </div>

                                <div class="col-md-4 col-sm-4 col-lg-4">
                                    <div class="form-group">
                                        <label for="LeadName">Teléfono Alternativo </label>
                                        <input type="text" class="form-control" v-model="vaCreCoti.telefono_s" placeholder="Ingrese un Nº de Telefono">
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-4 col-lg-4">
                                    <div class="form-group">
                                            <label>Vehiculo</label>

                                            <v-select
                                                v-model="vaCreCoti.nombreVehiculo"
                                                @search="selectVehiculo"
                                                label="nombre"
                                                :options="arrayVehiculo"
                                                placeholder="Buscar Vehiculo..."
                                                 @input="getDatosVehiculo"
                                            >
                                            <span slot="no-options">Lo siento, no hay opciones coincidentes.</span>
                                            </v-select>
                                    </div>
                                </div>

                                <div class="col-md-4 col-sm-4 col-lg-4">
                                    <div class="form-group">
                                        <label for="LeadName">Placa </label>
                                        <input type="text" class="form-control" v-model="vaCreCoti.placa" placeholder="Ingrese un Nº de Placa">
                                    </div>
                                </div>





                                <div class="col-md-4 col-sm-4 col-lg-4">
                                    <div class="form-group">
                                        <label for="estado">Estado</label>
                                        <select class="custom-select" v-model="vaCreCoti.estado">
                                            <option style="color:red;" value="0">Selecione un estado</option>
                                            <option style="color:red;" value="GESTION TELEFONICA">Gestion Telefonica</option>
                                            <option style="color:red;" value="VOLVER A LLAMAR">Volver A Llamar</option>
                                            <option style="color:red;" value="NUMERO INCORRECTO">Numero Incorrecto</option>
                                            <option style="color:red;" value="NO DESEA">No Desea</option>
                                            <option style="color:red;" value="AGENDAR">Agendar</option>
                                            <option style="color:red;" value="CITA">Cita</option>
                                            <option style="color:red;" value="SEGUIMIENTO DE CIERRE">Seguimiento De Cierre</option>
                                            <option value="RECOLECION DE DOCUMENTOS">Recolecion De Documentos</option>
                                            <option value="GESTION DE INSPECCION">Gestion De Inspeccion</option>
                                            <option value="GESTION DE EMISION">Gestion De Emision</option>
                                            <option value="GESTION DE LIBERACION">Gestion De Liberacion</option>
                                            <option value="PRELIQUIDACION">Preliquidacion</option>
                                        </select>
                                    </div>
                                </div>


                                <div class="col-md-4 col-sm-4 col-lg-4">
                                    <div class="form-group">
                                        <label>Suma Asegurada</label>
                                        <money  v-bind="money" v-model="vaCreCoti.suma_asegurada"  class="form-control"></money>
                                    </div>
                                </div>

                                 <div class="col-md-4 col-sm-4 col-lg-4">
                                    <div class="form-group">
                                        <label>Desgravamen</label>
                                        <money  v-bind="money" v-model="vaCreCoti.desgravamen"  class="form-control"></money>
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-4 col-lg-4">
                                    <div class="form-group">
                                        <label for="estado">Clasificación</label>
                                        <select class="custom-select" v-model="vaCreCoti.idClasificacion">
                                            <option value="0">Selecione una clasificación</option>
                                            <option v-for="cla in arrayClasificacion" :key="cla.id" :value="cla.id" v-text="cla.nombre"></option>

                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-4 col-lg-4">
                                    <div class="form-group">
                                        <label for="Tipo">Tipo de Uso</label>
                                        <select class="custom-select" v-model="vaCreCoti.idTipoUso">
                                            <option value="0">Selecione una Tipo Uso</option>
                                            <option v-for="cla in arrayTipoUso" :key="cla.id" :value="cla.id" v-text="cla.nombre"></option>

                                        </select>
                                    </div>
                                </div>


                                 <div class="col-md-4 col-sm-4 col-lg-4">
                                     <div class="form-group">
                                        <label for="LeadName">Vigencia Inicio</label>
                                        <input type="date" class="form-control" v-model="vaCreCoti.fecha_inicio" >

                                     </div>
                                 </div>

                                 <div class="col-md-4 col-sm-4 col-lg-4">
                                     <div class="form-group">
                                        <label for="LeadName">Vigencia Fin</label>
                                        <input type="date" class="form-control" v-model="vaCreCoti.fecha_fin" >

                                     </div>
                                 </div>


                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>Comentario</label>

                                        <el-input
                                            type="textarea"
                                            placeholder="Comentario"
                                            v-model="vaCreCoti.comentario"
                                            maxlength="255"
                                            :autosize="{ minRows: 1.3, maxRows: 4}"
                                            clearable
                                            show-word-limit
                                            >
                                        </el-input>
                                 </div>
                                </div>

                                 <div class="col-md-4 col-sm-4 col-lg-4">
                                     <div class="form-group">
                                        <label for="LeadName">Nuevo seguro a cotizar</label>

                                        <button  @click="abrirModal" type="button" class="btn btn-success form-control" ><i class="fas fa-plus-circle" ></i> Agregar Seguro a Cotizar</button>

                                     </div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-lg-12 " align="center">
                                    <h3>ANÁLISIS CUANTITATIVOS - SEGUROS: VEHÍCULOS</h3>
                                </div>
                                <div class="container-fluid scrollTableCotizacion" >
                                    <div class="row">
                                            <div class="col-md-6 col-sm-6 col-lg-6 " align="center" v-for="(c, index) in arrayCotizacion" :key="index">
                                                <div class="table-responsive">
                                                            <table class="table table-bordered"  >
                                                            <tbody>

                                                                <tr align="center">
                                                                    <th colspan="5"  scope="colgroup"> <button type="button" @click="eliminar_Detalle_seguro(index)" class="btn btn-danger btn-block"><i class="fas fa-trash-alt"></i> Quitar</button> </th>

                                                                </tr>
                                                                <tr>
                                                                    <td ROWSPAN=3>
                                                                         <template>
                                                                            <div class="center">
                                                                                <h4 for="" style="color: red; font-weight: bold;">Seleccionar? </h4>
                                                                            <vs-checkbox v-model="c.seleccionar">
                                                                                    {{((c.seleccionar==true) ? 'SI': 'NO')}}
                                                                            </vs-checkbox>
                                                                            </div>
                                                                        </template>
                                                                    </td>
                                                                    <th colspan="3" scope="colgroup" ><b v-text="'Seguro:'"></b> <label  v-text="'  '+c.seguro.nombre"></label> </th>
                                                                </tr>
                                                                <tr>
                                                                    <th scope="col" ><b>Tasa</b></th>
                                                                    <th scope="col"  colspan="2" ><b>Prima Neta</b></th>
                                                                </tr>
                                                                <tr>
                                                                    <th scope="col"  v-text="c.porcentaje_tasa + ' %'">3.20</th>
                                                                    <th scope="col" colspan="2"  v-text="'$ ' + (vaCreCoti.suma_asegurada*c.porcentaje_tasa / 100)"></th>
                                                                </tr>

                                                                <tr>

                                                                    <th scope="row"><b>Desgravamen</b></th>
                                                                    <td v-text="c.seguro.desgravamen + ' %'">56</td>
                                                                    <td colspan="2" v-text=" '$ ' + (c.desgravamen = evaluar_des_por(vaCreCoti.desgravamen, c.seguro.desgravamen))">22</td>

                                                                </tr>
                                                                <tr>

                                                                    <th scope="row" ><b> Auto * Auto</b></th>
                                                                    <td  style="width: 100px;">
                                                                        <template align="center">
                                                                            <div class="center">
                                                                                <label for="" style="color: red; font-weight: bold;">Aplica? </label>
                                                                            <vs-checkbox v-model="c.auto_auto_aplica">
                                                                                    {{((c.auto_auto_aplica) ? 'SI': 'NO')}}
                                                                            </vs-checkbox>
                                                                            </div>
                                                                        </template>
                                                                    </td>
                                                                    <td   v-text="'$ ' + c.seguro.auto_auto" style="width: 100px;">56</td>
                                                                    <td   v-text="((c.auto_auto_aplica) ? '$ ' + c.seguro.auto_auto : '')"  style="width: 100px;">56</td>



                                                                </tr>
                                                                <tr>
                                                                    <th scope="row"><b>0 Deducible</b></th>
                                                                    <td  colspan="3" v-text="'$ ' + c.seguro.cero_deducible">56</td>


                                                                </tr>
                                                                <tr>
                                                                    <th scope="row"><b>Amparo Patromonial</b></th>
                                                                    <td  colspan="3" v-text="'$ ' + c.seguro.amparo_patrimonial">56</td>


                                                                </tr>
                                                                <tr>
                                                                    <th scope="row"><b>Dispositivo de rastreo</b></th>
                                                                    <td  style="width: 100px;">
                                                                        <template align="center">
                                                                            <div class="center">
                                                                                <label for="" style="color: red; font-weight: bold;">Aplica? </label>
                                                                            <vs-checkbox v-model="c.dis_rastreo_aplica">
                                                                                    {{((c.dis_rastreo_aplica==true) ? 'SI': 'NO')}}
                                                                            </vs-checkbox>
                                                                            </div>
                                                                        </template>
                                                                    </td>
                                                                    <td colspan="2" v-text="'$ ' + c.seguro.dispositivo_rastreo">89</td>
                                                                </tr>
                                                                <tr>
                                                                    <th scope="col"> </th>
                                                                    <th scope="col" > <b>P .Neta:</b> </th>
                                                                    <th scope="col" colspan="2" v-if="c.auto_auto_aplica" v-text="arrayPrimaNeta[index].prima_neta=(vaCreCoti.suma_asegurada*c.porcentaje_tasa / 100 + parseFloat(c.seguro.auto_auto))"></th>
                                                                    <th scope="col" colspan="2" v-else v-text="arrayPrimaNeta[index].prima_neta=(vaCreCoti.suma_asegurada*c.porcentaje_tasa / 100 )"></th>
                                                                </tr>
                                                                <tr  align="center">
                                                                    <th class="table-primary"  scope="row" colspan="4"><b>Cobertura</b></th>
                                                                </tr>
                                                                <tr v-for="d in c.covertura" :key="d.id">
                                                                    <td scope="row" v-text="d.nombre"></td>
                                                                    <td colspan="3"   align="center" v-if="d.tipo_variable == 'TEXTO' && d.descripcion != ''" v-text="d.descripcion"></td>
                                                                    <td colspan="3"   align="center" v-else-if="d.tipo_variable == 'MONTO' && d.monto != 0" v-text="'US$ ' +  d.monto"></td>
                                                                    <td colspan="3"   align="center" v-else-if="d.tipo_variable == 'PORCENTAJE'" v-text="d.monto + '%'"></td>
                                                                    <td colspan="3"  align="center"  v-else><i class="fas fa-check"></i></td>

                                                                </tr>
                                                                <tr  align="center">
                                                                    <th class="table-primary"  scope="row" colspan="4"><b>Deducible</b></th>
                                                                </tr>
                                                                <tr v-for="d in c.deducible" :key="d.id">
                                                                    <td scope="row" v-text="d.nombre"></td>
                                                                    <td colspan="3"   align="center" v-if="d.tipo_variable == 'TEXTO' && d.descripcion != ''" v-text="d.descripcion"></td>
                                                                    <td colspan="3"   align="center" v-else-if="d.tipo_variable == 'MONTO' && d.monto != 0" v-text="'US$ ' +  d.monto"></td>
                                                                    <td colspan="3"   align="center" v-else-if="d.tipo_variable == 'PORCENTAJE'" v-text="d.monto + '%'"></td>
                                                                    <td colspan="3"  align="center"  v-else><i class="fas fa-check"></i></td>

                                                                </tr>
                                                                <tr>
                                                                    <td><b>PRIMA NETA:</b></td>

                                                                    <th scope="col" colspan="3" v-text="'$ ' + arrayPrimaNeta[index].prima_neta">$ 480</th>
                                                                </tr>
                                                                <tr>
                                                                    <td><b>SUPER BANCOS:</b></td>
                                                                    <td colspan="2">
                                                                        <money  v-bind="porcentaje_mo" v-model="c.s_bancos_por"  class="form-control"></money>
                                                                    </td>
                                                                    <td v-text="c.s_bancos = (arrayPrimaNeta[index].prima_neta * c.s_bancos_por / 100).toFixed(2)"></td>
                                                                </tr>
                                                                <tr>
                                                                    <td><b>S. CAMPESINO:</b></td>
                                                                    <td colspan="2">
                                                                        <money  v-bind="porcentaje_mo" v-model="c.s_campesino_por"  class="form-control"></money>
                                                                    </td>
                                                                    <td v-text="c.s_campesino=(arrayPrimaNeta[index].prima_neta * c.s_campesino_por / 100).toFixed(2)">34</td>
                                                                </tr>
                                                                <tr>
                                                                    <td> <b>S.S.C. NO COBRADO (2001 - 2007):</b></td>
                                                                    <td colspan="2"></td>
                                                                    <td></td>
                                                                </tr>
                                                                <tr>
                                                                    <td><b>DERECHOS DE EMISION:</b> </td>

                                                                    <td colspan="3" align="center" v-text=" c.derecho_emicion = evaluar_derecho_emicion(arrayPrimaNeta[index].prima_neta)"></td>
                                                                </tr>
                                                                <tr>
                                                                    <td><b>INTERES DE FINANCIACION: </b></td>
                                                                    <td colspan="2">
                                                                        <money  v-bind="porcentaje_mo" v-model="c.interes_financiamiento_por"  class="form-control"></money>
                                                                    </td>
                                                                    <td v-text="c.interes_financiamiento=((arrayPrimaNeta[index].prima_neta + parseFloat(c.s_bancos) + parseFloat(c.derecho_emicion) + parseFloat(c.s_campesino)) *c.interes_financiamiento_por / 100 ).toFixed(2)"></td>
                                                                </tr>
                                                                <tr>
                                                                    <td><b>IVA:</b></td>
                                                                    <td v-text="c.iva_por + ' %'"  colspan="2">34</td>
                                                                    <td v-if="c.interes_financiamiento!=0" v-text="c.iva_total=(parseFloat(c.interes_financiamiento) + parseFloat(c.s_bancos) + parseFloat(c.derecho_emicion) + parseFloat(c.s_campesino)).toFixed(2)">34</td>
                                                                    <td v-else v-text="c.iva_total=((arrayPrimaNeta[index].prima_neta + parseFloat(c.s_bancos) + parseFloat(c.derecho_emicion) + parseFloat(c.s_campesino))*c.iva_por/100).toFixed(2)">34</td>
                                                                </tr>
                                                                <tr  align="center">
                                                                    <th class="table-primary" scope="row" colspan="4"><b>CON DESCUENTO</b></th>
                                                                </tr>
                                                                <tr>
                                                                    <td><b>VALOR A PAGAR VEHICULO:</b></td>

                                                                    <td v-if="c.interes_financiamiento!=0" colspan="3" v-text="'US$ '+(c.valor_pagar_vehiculo=(arrayPrimaNeta[index].prima_neta +  parseFloat(c.iva_total) + 10).toFixed(2))">34</td>
                                                                    <td v-else colspan="3" v-text="'US$ '+(c.valor_pagar_vehiculo=(arrayPrimaNeta[index].prima_neta + parseFloat(c.s_bancos) +parseFloat(c.s_campesino) + parseFloat(c.derecho_emicion) + parseFloat(c.iva_total)).toFixed(2))">34</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><b>DESGRAVAMEN:</b></td>

                                                                    <td colspan="3" v-text="'US$ '+c.desgravamen"></td>
                                                                </tr>
                                                                <tr>
                                                                    <td><b>VALOR A PAGAR VEHICULO + DESGRAVAMEN + DISPOSITIVO RASTREO:</b></td>

                                                                    <td colspan="3" v-text="'US$ '+((c.dis_rastreo_aplica==true) ? (c.total = parseFloat(c.valor_pagar_vehiculo) +parseFloat(c.desgravamen) +parseFloat(c.seguro.dispositivo_rastreo)).toFixed(2) : (c.total = parseFloat(c.valor_pagar_vehiculo) +parseFloat(c.desgravamen)).toFixed(2))">34</td>

                                                                </tr>

                                                                </tbody>
                                                            </table>
                                                </div>

                                            </div>
                                    </div>

                                </div>

                            </div>


                            <br>
                            <div class="row">
                                <div class="col-12">
                                    <router-link class="btn btn-primary" :to="'/cotizaciones'"><i class="far fa-arrow-alt-circle-left"></i> Regresar</router-link>
                                    <button type="button"  class="btn btn-success" @click="actualizarCotizacion()">Actualizar Cotización</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
     <div class="modal fade " :class="{ show: modalShow }" :style=" modalShow ? mostrarModal : 'ocultarModal'" >
            <div class="modal-dialog modal-md modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title mt-0 font-16" id="myLargeModalLabel" v-text="tituloModal">Registrar Usuario</h5>
                        <button type="button" @click="abrirModal" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">
                       <form>
                           <div class="row">

                                <div class="col-md-12 col-sm-12 col-lg-12">
                                    <div class="form-group">
                                            <label>Seguro</label>

                                            <v-select multiple
                                                v-model="nombreSeguro"
                                                label="nombre"
                                                :options="arraySeguro"
                                                placeholder="Buscar Seguro..."

                                            >
                                            <span slot="no-options">Lo siento, no hay opciones coincidentes.</span>
                                            </v-select>
                                    </div>
                                </div>

                                 <div class="col-md-12 col-sm-12 col-lg-12">
                                    <div class="form-group">
                                        <label for="estado">Tasas</label>
                                        <money  v-bind="porcentaje_mo" v-model="tasa_automatico"  class="form-control"></money>

                                        <!-- <select class="custom-select" v-model="idTasaSeguro">
                                            <option value="0">Selecione una Tasa</option>
                                            <option v-for="cla in arrayTasas" :key="cla.id" :value="cla.id" v-text="cla.tasa"></option>

                                        </select> -->
                                    </div>
                                </div>


                            </div>

                        </form>
                    </div>

                     <div class="modal-footer">
                            <button type="button" class="btn btn-sm btn-primary" @click="tasas_seguro_agregar()" >Agregar</button>
                            <button type="button" class="btn btn-sm btn-secondary" @click="abrirModal">Cerrar</button>
                     </div>

                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
        </div>
    
    </div>

</div>
</template>

<script>

import {alertasM} from '../../../util.js';
import PdfViewer from "vue-pdf-app";
export default {
    props: ['ruta', 'iva_data'],
    components: {
    PdfViewer
  },
    data() {
        return {
      
            AsignarRolPermisosByUsuario: JSON.parse(localStorage.getItem('listRolPermisosByUsuario')),
        
            arrayCliente: [],//cliente
            arrayVehiculo: [],//vehiculo
            arrayClasificacion: [],//clasificacion
            arraySeguro: [],//Seguro
            arrayTasas: [],//Tasas
            arrayTipoUso: [],//Tasas
            arrayCoberturas: [],
            arrayDeducibles: [],
            vaCreCoti: {

                idcliente: 0,
                nombreCliente: '',
                edadCliente: 0,
                suma_asegurada: 0.0,
                idVehiculo: 0,
                nombreVehiculo: '',
                estado: 0,
                idClasificacion: 0,
                fecha_inicio: null,
                fecha_fin: null,

                desgravamen: 0.0,
                idTipoUso: 0.0,
                placa: '',
                telefono_s: '',
                comentario: '',
                iduser: 0,
                anio_antiguedad: 0

            },
            modalShow: false,
            mostrarModal: {
                display: 'block',
                background: '#0000006b'
            },
            ocultarModal: {
                display: 'none'
            },
            idasesor: null,
            nombreAswsor: null,

            money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '$ ',
                    suffix: '',
                    precision: 2,
                    masked: false
            },

            porcentaje_mo: {
                    decimal: ',',
                    thousands: '',
                    prefix: '',
                    suffix: ' %',
                    precision: 2,
                    masked: false
            },
            nombreSeguro: '',
            idSeguro: 0,
            idTasaSeguro: 0, // id de la tasa
            arrayCotizacion:[],
            arrayPrimaNeta: [],
            arrayDetalle: [],
           
            aTipoDocumento: [],
           
            idCotizacion: this.change_cotizacion_id,
            registrar_actualizar: 1, //1registrar 2 actualziar
            actualizar_seguros: false,//si hay algun seguro seleccionado entonces e no se edita, si no hay seguros, si se edit

            bloquear_seguros: false,// al editar verificamos si hay un seguro seleccionado. de ser asi, entonces se bloquea
            usuario: [],
            tituloModal: '',
            tasa_automatico: 0


        }
    },
    mixins: [alertasM],

    computed: {
        change_cotizacion_id:{
            get() {
                return this.$route.params.id
            },
            set(value) {
            },
        },
    },
    methods: {

        //Busqueda del cliente
        selectCliente(search,loading,defecto){
            let me=this;
                var url=  '/cotizacion/getlistcliente';

                if(defecto==null){
                    loading(true)
                    axios.get(url,{ params:{ 'filtro': search } } )
                        .then(function (response) {
                        let respuesta = response.data;
                        q: search
                        me.arrayCliente=respuesta;
                        loading(false)
                    })
                    .catch(function (error) {
                        console.log(error);
                        if (err.response.status == 401) {
                            if (localStorage['authUser']) {
                                this.$router.push({name: 'login'})
                                location.reload();
                                localStorage.clear();
                            }
                        }
                    });
                }else{

                    axios.get(url,{ params:{ 'filtro': search} } )
                        .then(function (response) {
                        let respuesta = response.data;
                        me.arrayCliente=respuesta;

                    })
                    .catch(function (error) {
                        console.log(error);
                        if (error.response.status == 401) {
                        if (localStorage['authUser']) {
                            this.$router.push({name: 'login'})
                            location.reload();
                            localStorage.clear();
                        }
                        }
                    });

                }
        },

        getDatosCliente(val1){
            let me = this;
                 if(val1 ==null){
                     me.vaCreCoti.idcliente = 0;
                     me.vaCreCoti.nombreCliente = "";
                     me.vaCreCoti.edadCliente = 0;
                 }else{

                     me.loading = true;
                     me.vaCreCoti.idcliente = val1.id;
                     me.vaCreCoti.nombreCliente = val1.nombre;
                     me.vaCreCoti.edadCliente = val1.edad;
                 }
        },

        //Busqueda del Vehiculo
        selectVehiculo(search,loading,defecto){

             let me=this;
                var url=  '/cotizacion/getlistvehiculo';

                if(defecto==null){
                    loading(true)
                    axios.get(url,{ params:{ 'filtro': search } } )
                        .then(function (response) {
                        let respuesta = response.data;
                        q: search
                        me.arrayVehiculo=respuesta;
                        loading(false)
                    })
                    .catch(function (error) {

                        if (err.response.status == 401) {
                            if (localStorage['authUser']) {
                                this.$router.push({name: 'login'})
                                location.reload();
                                localStorage.clear();
                            }
                        }
                                console.log(error);
                    });
                }else{

                    axios.get(url,{ params:{ 'filtro': search} } )
                        .then(function (response) {
                        let respuesta = response.data;
                        me.arrayVehiculo=respuesta;

                    })
                    .catch(function (error) {
                         // console.log("hola --" + localStorage['authUser']);
                        if (error.response.status == 401) {
                            //this.$router.push({name: 'login'})
                            location.reload();
                            localStorage.clear();

                        }
                            console.log(error);
                    });

                }

        },

        getDatosVehiculo(val1){
             let me = this;
                 if(val1 ==null){
                     me.vaCreCoti.idVehiculo = 0;
                     me.vaCreCoti.nombreVehiculo = "";
                 }else{

                     me.loading = true;
                     me.vaCreCoti.idVehiculo = val1.id;
                     me.vaCreCoti.nombreVehiculo = val1.nombre;
                 }
        },


        //Tipo de uso


        getSelectCobeDedu(){

            var url = '/seguro/list';

            axios.get(url)
            .then(res => {
                var respuesta = res.data;
                this.arrayCoberturas = respuesta.cobertura;
                this.arrayDeducibles = respuesta.deducible;
            })
            .catch(err => {
                console.log(error);
                        if (err.response.status == 401) {
                            if (localStorage['authUser']) {
                                this.$router.push({name: 'login'})
                                location.reload();
                                localStorage.clear();
                            }
                        }
            })
        },
    
    
       
        tasas_seguro_cotizar(id){

             var url = '/cotizacion/getlisttasas';

           axios.post(url,{'id':id})
            .then(res => {
                var respuesta = res.data;
                this.arrayTasas = respuesta;
            })
            .catch(err => {
                console.log(error);
                        if (err.response.status == 401) {
                            if (localStorage['authUser']) {
                                this.$router.push({name: 'login'})
                                location.reload();
                                localStorage.clear();
                            }
                        }
            })
        },
    //Agregamos el seguro a cotizar
         tasas_seguro_agregar(){
            var me = this;
            var url = '/cotizacion/getlistSeguroTotal';
           // me.openCargando();

               // console.log(me.nombreSeguro.length);
            if((me.nombreSeguro.length) <= 0){
               // me.openCargando(true);
                me.notify(" Seleccione almenos un seguro","","top","right","fas fa-exclamation-triangle","danger",' flipInX','flipOutX')
                return
            }
            me.openCargando();

            me.nombreSeguro.forEach(element => {
                console.log(element.id);
                axios.post(url,{'id': element.id})
                    .then(res => {
                        var respuesta = res.data;

                        me.arrayCotizacion.push({
                                seguro: respuesta.seguro,
                                dis_rastreo_aplica: false,
                                deducible: respuesta.deducible,
                                covertura: respuesta.covertura,
                                porcentaje_tasa: me.tasa_automatico,
                                auto_auto_aplica: false,
                                interes_financiamiento_por: 0,
                                interes_financiamiento: 0,
                                derecho_emicion: 0,
                                s_bancos_por: 3.50,
                                s_bancos: 0,
                                s_campesino_por: 0.50,
                                s_campesino: 0,
                                iva_por: this.iva_data,
                                iva_total: 0,
                                valor_pagar_vehiculo: 0,
                                desgravamen: 0,
                                total: 0,
                                seleccionar: false,

                        });

                        me.arrayPrimaNeta.push({
                            prima_neta: 0
                        });
                    })
                    .catch(err => {
                        console.log(err);
                        if (err.response.status == 401) {
                            if (localStorage['authUser']) {
                                this.$router.push({name: 'login'})
                                location.reload();
                                localStorage.clear();
                            }
                        }
                    })
            });
            me.arraySeguro = [];
            me.selectTipoSeguro('',false,1)
            me.nombreSeguro=null;
            me.openCargando(true);
           
        },

        //Busqueda del tipo seguro
        selectTipoSeguro(search,loading,defecto){

             let me=this;
                var url=  '/cotizacion/getlisttiposeguro';

                if(defecto==null){
                    loading(true)
                    axios.get(url,{ params:{ 'filtro': search } } )
                        .then(function (response) {
                        let respuesta = response.data;
                        q: search
                        me.arraySeguro=respuesta;
                        loading(false)
                    })
                    .catch(function (error) {
                        console.log(error);
                        if (err.response.status == 401) {
                            if (localStorage['authUser']) {
                                this.$router.push({name: 'login'})
                                location.reload();
                                localStorage.clear();
                            }
                        }
                    });
                }else{

                    axios.get(url,{ params:{ 'filtro': search} } )
                        .then(function (response) {
                        let respuesta = response.data;
                        me.arraySeguro=respuesta;

                    })
                    .catch(function (error) {
                        console.log(error);
                        if (error.response.status == 401) {
                        if (localStorage['authUser']) {
                            this.$router.push({name: 'login'})
                            location.reload();
                            localStorage.clear();
                        }
                        }
                    });

                }

        },

        evaluar_des_por(degravamen, porcen){
            // console.log(degravamen);
                if (degravamen == 0 && porcen == 0) {

                    return 0
                } else if (porcen == 0) {
                    return 150
                } else if (degravamen == 0) {
                    return 0
                } else if (porcen > 0) {
                    var  total = degravamen * porcen / 100;
                    if (total < 104.50) {

                        total = 104.50;
                        return total
                    }else{

                        return total
                    }

                }
        },

        evaluar_derecho_emicion(primaNeta){

             var  emision = 0;

            if (primaNeta > 0 && primaNeta <= 250) {
            emision = 0.5;
            //primaNeta = primaNeta + emision;
            } else if (primaNeta >= 251 && primaNeta <= 500) {
                emision = 1;
                //primaNeta = primaNeta + emision;
            } else if (primaNeta >= 501 && primaNeta <= 1000) {
                emision = 3;
                //primaNeta = primaNeta + emision;
            } else if (primaNeta >= 1001 && primaNeta <= 2000) {
                emision = 5;
            // primaNeta = primaNeta + emision;
            } else if (primaNeta >= 2001 && primaNeta <= 4000) {
                emision = 7;
                //primaNeta = primaNeta + emision;
            } else if (primaNeta >= 4001 && primaNeta <= 100000) {
                emision = 9;
                //primaNeta = primaNeta + emision;
            }
            return emision
        },

        //Eliminar un seguro que se va a cotizar
        eliminar_Detalle_seguro(index){
            let me = this;
            me.arrayCotizacion.splice(index, 1);
        },
        //Evitar que se agregue doble vez
        encuentra(id,idTasa){
                var sw=0;
                for(var i=0;i<this.arrayCotizacion.length;i++){
                    if(this.arrayCotizacion[i].seguro.id==id){
                        sw=true;
                    }
                }
                return sw;
        },
        //Verificar que solo se seleccione un seguro
        verificar_seleccion(){
             var sw=0;
                for(var i=0;i<this.arrayCotizacion.length;i++){

                    if(this.arrayCotizacion[i].seleccionar==true){
                        sw++;
                    }
                }
                //console.log(sw);
               return sw;
        },

        cleanVariables(){
                var me = this;
                me.vaCreCoti.idcliente = 0;
                me.vaCreCoti.nombreCliente = '';
                me.vaCreCoti.anio_antiguedad = 0;
                me.vaCreCoti.edadCliente = 0;
                me.vaCreCoti.suma_asegurada = 0.0;
                me.vaCreCoti.idVehiculo = 0;
                me.vaCreCoti.nombreVehiculo = '';
                me.vaCreCoti.estado = 0;
                me.vaCreCoti.idClasificacion = 0;
                me.vaCreCoti.fecha_inicio = null;
                me.vaCreCoti.fecha_fin = null;
                me.vaCreCoti.desgravamen = 0.0;
                me.vaCreCoti.idTipoUso = 0.0;
                me.vaCreCoti.placa = '';
                me.vaCreCoti.telefono_s = '';
                me.vaCreCoti.comentario = '';
                me.arrayCotizacion = [];
                me.idCotizacion = null;
                me.url_pdf = null;
                me.bloquear_seguros = false;
        },

        //Agregar Cliente
        getSelectTipoDoc(){

            var url = '/administracion/usuario/getListarDocumentos';

            axios.get(url)
            .then(res => {

                var respuesta = res.data;
                this.aTipoDocumento = respuesta.documento;
                //console.log(respuesta.documento);

            })
            .catch(err => {

                console.error(err);
                 if (err.response.status == 401) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }
            })
        },


        CargareditarCotizacion(id){

            let me = this;
            me.openCargando();
            var url = '/cotizacion/editardetalle';
            me.idCotizacion = id;

            axios.post(url,{'id': id})
             .then(res => {

                var respuesta       = res.data;

                me.arrayVehiculo        = respuesta.modelo;
                me.arrayCliente         = respuesta.cliente;
                me.arrayClasificacion   = respuesta.clasificacion;
                me.arrayTipoUso         = respuesta.tipo_uso;

                me.vaCreCoti.idcliente =  respuesta.cotizacion['idcliente'];
                me.arrayCliente.forEach(e => {
                        if(respuesta.cotizacion['idcliente'] == e.id){
                            me.vaCreCoti.nombreCliente =  e.nombre;
                            me.vaCreCoti.edadCliente =  e.edad;
                        }
                });

                me.vaCreCoti.suma_asegurada =  respuesta.cotizacion['suma_asegurada'],

                me.arrayVehiculo.forEach(e => {
                    if(respuesta.cotizacion['idmodelo'] == e.id){
                            me.vaCreCoti.idVehiculo =  e.id;
                            me.vaCreCoti.nombreVehiculo =  e.nombre;
                        }
                });
                
                me.vaCreCoti.anio_antiguedad        =  respuesta.cotizacion['anio_antiguedad'];
                me.vaCreCoti.estado                 =  respuesta.cotizacion['estado'];
                me.vaCreCoti.idClasificacion        =  respuesta.cotizacion['idclasificacion'];
                me.vaCreCoti.fecha_inicio           =  respuesta.cotizacion['vigencia_inicio'];
                me.vaCreCoti.fecha_fin              =  respuesta.cotizacion['vigencia_fin'];
                me.vaCreCoti.desgravamen            =  respuesta.cotizacion['desgravamen'];
                me.vaCreCoti.idTipoUso              =  respuesta.cotizacion['idtipo_uso'];
                me.vaCreCoti.placa                  =  respuesta.cotizacion['placa'];
                me.vaCreCoti.telefono_s             =  respuesta.cotizacion['telefono'];
                me.vaCreCoti.comentario             =  respuesta.cotizacion['comentario']; //iduser
                me.vaCreCoti.iduser                 =  respuesta.cotizacion['iduser'];

                respuesta.detalle.forEach(e => {

                    me.arrayCotizacion.push({
                        seguro: e.seguro[0],
                        dis_rastreo_aplica: ((e.cotizacion_seguro_detalle.dis_rastreo_aplica == 1) ? true : false),
                        deducible: e.deducible,
                        covertura: e.covertura,
                        porcentaje_tasa: e.porcentaje_tasa,
                        auto_auto_aplica: ((e.cotizacion_seguro_detalle.auto_auto_aplica == 1) ? true : false),
                        interes_financiamiento_por: e.cotizacion_seguro_detalle.interes_financiamiento_por,
                        interes_financiamiento: 0,
                        derecho_emicion: 0,
                        s_bancos_por:  e.cotizacion_seguro_detalle.s_bancos_por,
                        s_bancos: 0,
                        s_campesino_por: e.cotizacion_seguro_detalle.s_campesino_por,
                        s_campesino: 0,
                        iva_por: e.cotizacion_seguro_detalle.iva_por,
                        iva_total: 0,
                        valor_pagar_vehiculo: 0,
                        desgravamen: 0,
                        total: 0,
                        seleccionar: ((e.cotizacion_seguro_detalle.seleccionar == 'SI') ? true : false),
                        id_cotizacion_seguro: e.id_cotizacion_seguro

                    });

                    me.arrayPrimaNeta.push({
                        prima_neta: 0
                    });

                    if(e.cotizacion_seguro_detalle.seleccionar == 'SI'){
                            me.bloquear_seguros = true;
                    }

                });
                
                me.registrar_actualizar=2
                me.openCargando(true);

               //console.log(respuesta.detalle)
             })
             .catch(err => {
                 console.log(err);
                  me.openCargando(true);
                 this.cleanVariables();
                    if (err.response.status == 401) {
                        if (localStorage['authUser']) {
                            this.$router.push({name: 'login'})
                            location.reload();
                            localStorage.clear();
                        }
                    }
             })

        },

        actualizarCotizacion(){

            var me = this;
            var veri = false;
            var url = '/cotizacion/actualizar';
            this.openCargando();

            if (me.verificar_seleccion() > 1){
                me.openCargando(true);

                me.notify(" Seleccione solo un seguro a emitir","","top","right","fas fa-exclamation-triangle","danger",' flipInX','flipOutX')
                return
            }
            //Evaluamos que el estado este en algunos de los mencionados
            //si esta, entonces evaluamos que solo este selecionado un seguro, de lo contrario mandamor error
            switch (me.vaCreCoti.estado) {
                case 'RECOLECION DE DOCUMENTOS':
                    veri = true;
                    break;
                case 'GESTION DE INSPECCION':
                    veri = true;
                    break;

                case 'GESTION DE EMISION':
                    veri = true;
                    break;
                case 'GESTION DE LIBERACION':
                    veri = true;
                    break;
                case 'PRELIQUIDACION':
                    veri = true;
                    break;
                default:
                    veri = false;
                    break;
            }

            if(veri == true){

                if (me.verificar_seleccion() == 1){

                }else{
                    me.openCargando(true);
                    me.notify(" Seleccione un seguro a emitir","","top","right","fas fa-exclamation-triangle","danger",' flipInX','flipOutX')
                    return
                }
            }


            if (me.arrayCotizacion.length<=0){
                me.openCargando(true);
                me.notify(" Agregue almenos un seguro a cotizar","","top","right","fas fa-exclamation-triangle","danger",' flipInX','flipOutX')
                return
            }



            axios.post(url, {

                'vaCreCoti': me.vaCreCoti,
                'arrayCotizacion' :me.arrayCotizacion,
                'arrayPrimaNeta' : me.arrayPrimaNeta,
                'id': me.idCotizacion
            }).
            then(res => {


                if(res.data.status){

                    me.openCargando(true);
                    me.notify(" Cotización actualizada con éxito","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                    me.cleanVariables();
                    this.$router.push({name: 'cotizacion.index'})
                  
                }else{
                    me.openCargando(true);
                    me.notify(" Ha ocurrido un error al actualizar la Cotización","","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')
                    console.error(res.data.mensaje);
                }

            })
            .catch(err => {
                me.openCargando(true);//Desactivamos ventana de carga de bloqueo

                for(var key in err.response.data.errors){
                    me.notify(" " + err.response.data.errors[key],"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')
                }
                if(err.response.status == 401) {
                    if (localStorage['authUser']) {
                        me.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       me.openCargando(true);//Desactivamos ventana de carga de bloqueo
                       }
                }
                console.error(err);
             }
            )
        },

       
         abrirModal() {
            this.modalShow = !this.modalShow;

            if(this.modalShow==true){

                this.tituloModal = "Agregar Cotizacion";
                this.tasa_automatico =  this.calcular_tasas(this.vaCreCoti.edadCliente, this.vaCreCoti.anio_antiguedad, this.vaCreCoti.suma_asegurada);
                 this.selectTipoSeguro('',false,1)

            }else{

            }
        },

        editarCotiNoti(id){
            if(id==null || id == ''){
                this.$router.push({name: 'cotizacion.index'})
            }else{
              

                //this.selectVehiculo('',false,1)
                //this.selectCliente('',false,1)
                //this.getSelectClasificaciion()
               // this.getSelectTipoUso()
                this.CargareditarCotizacion(id)
            }
        },

        calcular_tasas(edad_v, antiguedad_v, valor_asegurado_v){
            let edad = edad_v
            let antiguedad = antiguedad_v
            let valor_asegurado = valor_asegurado_v

            if(edad >= 18 && edad <= 25  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 2.70
            if(edad >= 18 && edad <= 25  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 2.80
            if(edad >= 18 && edad <= 25  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 2.90
            if(edad >= 18 && edad <= 25  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 3.00
            if(edad >= 18 && edad <= 25  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 3.10
   
            if(edad >= 18 && edad <= 25  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 3.30
            if(edad >= 18 && edad <= 25  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 3.35
            if(edad >= 18 && edad <= 25  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 3.40
            if(edad >= 18 && edad <= 25  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 3.45
            if(edad >= 18 && edad <= 25  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 3.50
 
            if(edad >= 18 && edad <= 25  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 3.30
            if(edad >= 18 && edad <= 25  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 3.40
            if(edad >= 18 && edad <= 25  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 3.45
            if(edad >= 18 && edad <= 25  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 3.50
            if(edad >= 18 && edad <= 25  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 3.60

            if(edad >= 18 && edad <= 25  && antiguedad >=  11 && antiguedad <=  15 &&  valor_asegurado >= 30000 && valor_asegurado <= 100000) return 4.30

            if(edad >= 18 && edad <= 25  && antiguedad >=  11 && antiguedad <=  15 &&  valor_asegurado >= 0     && valor_asegurado <= 29999)  return 5.00

            if(edad >= 26 && edad <= 32  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 2.60
            if(edad >= 26 && edad <= 32  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 2.70
            if(edad >= 26 && edad <= 32  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 2.80
            if(edad >= 26 && edad <= 32  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 2.90
            if(edad >= 26 && edad <= 32  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 3.00

            if(edad >= 26 && edad <= 32  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 3.25
            if(edad >= 26 && edad <= 32  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 3.30
            if(edad >= 26 && edad <= 32  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 3.35
            if(edad >= 26 && edad <= 32  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 3.40
            if(edad >= 26 && edad <= 32  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 3.45

            if(edad >= 26 && edad <= 32  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 3.30
            if(edad >= 26 && edad <= 32  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 3.35
            if(edad >= 26 && edad <= 32  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 3.40
            if(edad >= 26 && edad <= 32  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 3.45
            if(edad >= 26 && edad <= 32  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 3.50

            if(edad >= 26 && edad <= 32  && antiguedad >=  11 && antiguedad <=  15 &&  valor_asegurado >= 30000 && valor_asegurado <= 100000) return 4.20

            if(edad >= 26 && edad <= 32  && antiguedad >=  11 && antiguedad <=  15 &&  valor_asegurado >= 0     && valor_asegurado <= 29000)  return 4.80

            if(edad >= 33 && edad <= 40  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 2.50
            if(edad >= 33 && edad <= 40  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 2.60
            if(edad >= 33 && edad <= 40  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 2.70
            if(edad >= 33 && edad <= 40  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 2.80
            if(edad >= 33 && edad <= 40  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 2.90

            if(edad >= 33 && edad <= 40  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 3.20
            if(edad >= 33 && edad <= 40  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 3.25
            if(edad >= 33 && edad <= 40  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 3.30
            if(edad >= 33 && edad <= 40  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 3.35
            if(edad >= 33 && edad <= 40  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 3.40

            if(edad >= 33 && edad <= 40  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 3.25
            if(edad >= 33 && edad <= 40  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 3.30
            if(edad >= 33 && edad <= 40  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 3.35
            if(edad >= 33 && edad <= 40  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 3.40
            if(edad >= 33 && edad <= 40  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 3.45

            if(edad >= 33 && edad <= 40  && antiguedad >=  11 && antiguedad <=  15 &&  valor_asegurado >= 30000 && valor_asegurado <= 100000) return 4.10

            if(edad >= 33 && edad <= 40  && antiguedad >=  11 && antiguedad <=  15 &&  valor_asegurado >= 0     && valor_asegurado <= 29000)  return 4.70
            
            if(edad >= 41 && edad <= 75  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 2.40
            if(edad >= 41 && edad <= 75  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 2.50
            if(edad >= 41 && edad <= 75  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 2.60
            if(edad >= 41 && edad <= 75  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 2.70
            if(edad >= 41 && edad <= 75  && antiguedad >=  0  && antiguedad <=  3  &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 2.80

            if(edad >= 41 && edad <= 75  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 3.10
            if(edad >= 41 && edad <= 75  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 3.20
            if(edad >= 41 && edad <= 75  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 3.25
            if(edad >= 41 && edad <= 75  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 3.30
            if(edad >= 41 && edad <= 75  && antiguedad >=  4  && antiguedad <=  6  &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 3.35

            if(edad >= 41 && edad <= 75  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 70000 && valor_asegurado <= 100000) return 2.20
            if(edad >= 41 && edad <= 75  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 40000 && valor_asegurado <= 69999)  return 2.25
            if(edad >= 41 && edad <= 75  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 30000 && valor_asegurado <= 39999)  return 3.00
            if(edad >= 41 && edad <= 75  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 20000 && valor_asegurado <= 29999)  return 3.35
            if(edad >= 41 && edad <= 75  && antiguedad >=  7  && antiguedad <=  10 &&  valor_asegurado >= 0     && valor_asegurado <= 19999)  return 3.40

            if(edad >= 41 && edad <= 75  && antiguedad >=  11 && antiguedad <=  15 &&  valor_asegurado >= 30000 && valor_asegurado <= 100000) return 4.00

            if(edad >= 41 && edad <= 75  && antiguedad >=  11 && antiguedad <=  15 &&  valor_asegurado >= 0     && valor_asegurado <= 29000)  return 4.50
            return 0

        }

    },
    
    watch:{
        change_cotizacion_id(newVal, oldVal){
            //this.titulo = newVal;
            this.idCotizacion = newVal;

            this.editarCotiNoti(newVal);
        },
    },
    mounted() {

       this.editarCotiNoti(this.$route.params.id);

    },
}
</script>

<style>

</style>
